import { useEffect, useState } from "react";
import { Alert, Box, Button, Card, CircularProgress, Stack, Typography } from "@mui/material";
import { checkTrayAuthentication, getTrayConfig, redirectToTrayAuthorization } from "services/tray";

export default function TrayConnectionAdmin() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState(null);
  const verify = async () => {
    setBusy(true);
    setError("");
    setStatus(null);
    try {
      const config = await getTrayConfig();
      await checkTrayAuthentication();
      setStatus(`Loja ${config.storeId} conectada ao PSO.`);
    } catch (failure) {
      setError(failure.message);
    } finally {
      setBusy(false);
    }
  };
  useEffect(() => {
    verify();
  }, []);
  const connect = async () => {
    setBusy(true);
    setError("");
    try {
      await redirectToTrayAuthorization();
    } catch (failure) {
      setError(failure.message);
      setBusy(false);
    }
  };
  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h6" mb={2}>
        Conexão da loja Tray
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Apenas o administrador conecta a loja. Os autores entram com suas contas PSO e publicam
        usando a conexão mantida pelo servidor.
      </Alert>
      {busy && (
        <Box mb={2}>
          <CircularProgress size={24} />
        </Box>
      )}
      {status && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {status}
        </Alert>
      )}
      {error && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Typography variant="body2" mb={2}>
        Ao conectar, você será direcionado ao painel Tray. Se a sessão desse painel expirou, entre
        com o acesso administrativo da loja e autorize o aplicativo. A autorização fica salva no
        servidor e é renovada automaticamente enquanto válida.
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Button variant="outlined" disabled={busy} onClick={connect}>
          Conectar / reautorizar loja
        </Button>
        <Button disabled={busy} onClick={verify}>
          Verificar conexão
        </Button>
      </Stack>
    </Card>
  );
}
